import StatusCodes from '@/v2/constants/StatusCodes';

const maxRetries = 3;

export default function retryPolicy(failureCount, error) {
  const statusCode = error?.response?.status;
  const nonRetryableStatusCodes = [
    StatusCodes.UNAUTHORIZED_ERROR_CODE,
    StatusCodes.PAYMENT_REQUIRED,
    StatusCodes.SSO_INVALID_TOKEN_ERROR_CODE,
  ];

  return (
    !nonRetryableStatusCodes.includes(statusCode) && failureCount < maxRetries
  );
}
